module.exports = __webpack_public_path__ + "img/MONTAJE.f1ca2d69.png";